export default __webpack_public_path__ + "locales/el-GR/SharingPanel.json?hash=cfc742d19f0c961a19f56d0d89c3d31a";